<template>
  <div>
    <div v-if="think" class="think-box">
      <div>
        <i @click="toggleThink" :class="showThink ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
      <div class="think-box-content">
        <div class="vertical-line-flex"></div>
        <div v-show="showThink" class="markdown-body" v-html="compiledThinkMarkdown"></div>
      </div>
    </div>
    <div class="markdown-body" v-html="compiledMarkdown"></div>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import {mapState} from "vuex";

export default {
  props: {
    enableDelay: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      required: true,
    },
    sourceFinished: {
      type: Boolean,
      required: true,
    },
    sourceCount: {
      type: Number,
      default: 0
    },
    think: {
      type: String,
      default: '',
    },
    thinkFinished: {
      type: Boolean,
      default: true,
    },
    thinkCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showThink: true,
      sourceTimer: null,
      thinkTimer: null
    };
  },
  computed: {
    ...mapState({
      messageStreamDelay: (state) => state.business.sysConfig.messageStreamDelay,
    }),
    compiledMarkdown() {
      // 初始化 markdown-it 实例
      const md = new MarkdownIt({
        breaks: true, // 启用换行符支持
        html: true, // 启用 HTML 标签支持
        linkify: true, // 自动识别 URL 链接
        typographer: true, // 启用智能标点符号替换
      });
      md.renderer.rules.html_inline = (tokens, idx, options, env, self) => {
        const token = tokens[idx];

        if (token.content.includes("<think>")) {
          return `<p class='think-box'>`;
        }
        if (token.content.includes("</think>")) {
          return `</p>`;
        }
        return self.renderToken(tokens, idx, options);
      };

      // 超链接打开新窗口
      md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        const aIndex = tokens[idx].attrIndex('target');

        if (aIndex !== -1) {
          // 如果已经有 target 属性，则不做处理
          return self.renderToken(tokens, idx, options);
        }

        // 添加 target="_blank" 属性
        tokens[idx].attrPush(['target', '_blank']);
        tokens[idx].attrPush(['rel', 'noopener noreferrer']);

        // 渲染标签
        return self.renderToken(tokens, idx, options);
      }

      // 使用 markdown-it 解析 Markdown 文本
      let source = this.enableDelay ?  this.source.substring(0, this.sourceCount) : this.source
      return md.render(source);
    },
    compiledThinkMarkdown() {
      // 初始化 markdown-it 实例
      const md = new MarkdownIt({
        breaks: true, // 启用换行符支持
        html: true, // 启用 HTML 标签支持
        linkify: true, // 自动识别 URL 链接
        typographer: true, // 启用智能标点符号替换
      });
      md.renderer.rules.html_inline = (tokens, idx, options, env, self) => {
        const token = tokens[idx];

        if (token.content.includes("<think>")) {
          return `<p class='think-box'>`;
        }
        if (token.content.includes("</think>")) {
          return `</p>`;
        }
        return self.renderToken(tokens, idx, options);
      };

      // 超链接打开新窗口
      md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        const aIndex = tokens[idx].attrIndex('target');

        if (aIndex !== -1) {
          // 如果已经有 target 属性，则不做处理
          return self.renderToken(tokens, idx, options);
        }

        // 添加 target="_blank" 属性
        tokens[idx].attrPush(['target', '_blank']);
        tokens[idx].attrPush(['rel', 'noopener noreferrer']);

        // 渲染标签
        return self.renderToken(tokens, idx, options);
      }

      // 使用 markdown-it 解析 Markdown 文本
      let think = this.enableDelay ?  this.think.substring(0, this.thinkCount): this.think
      return md.render(think);
    },
  },
  methods: {
    startSourceTimer() {
      const delay = this.messageStreamDelay ? this.messageStreamDelay : 150
      this.sourceTimer = setInterval(()=> {
         if(this.source) {
           if(this.sourceFinished && this.source.length === this.sourceCount) {
             clearInterval(this.sourceTimer)
           } else {
             this.sourceCount += 1
           }
         }

      }, delay)
    },
    startThinkTimer() {
      const delay = this.messageStreamDelay ? this.messageStreamDelay : 150
      if(this.think) {
        this.thinkTimer = setInterval(()=> {
          if(this.think) {
            if(this.thinkFinished && this.think.length === this.thinkCount) {
              clearInterval(this.thinkTimer)
            } else {
              this.thinkCount += 1
            }
          }

        }, delay)
      }
    },
    toggleThink() {
      this.showThink = !this.showThink;
    },
  },
  mounted() {
    if(this.enableDelay) {
      this.startThinkTimer()
      this.startSourceTimer()
    }

  }
};
</script>
<style scoped lang="scss">
::v-deep ol,
::v-deep ul {
  padding-left: 15px;
}
::v-deep .think-box {
  color: gray;
  font-size: 12px;
}
::v-deep .think-box-content {
  display: flex;
}
::v-deep .think-box-content .vertical-line-flex {
  width: 2px;
  background-color: lightgray;
  margin: 0 5px;
}
::v-deep .markdown-body {
  flex: 1;

  * {
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
  }
}
</style>
